import { makeVar, ReactiveVar } from '@apollo/client';
import { createError, AnalyticIdentifier } from '@common/neo.tax';

import { reactiveVarOrchestrator } from '../orchestrators';

export type AnalyticIds = Record<string, true>;
export type AnalyticIdsVar = ReactiveVar<Record<string, true>>;
export type AnalyticIdOptions = {
  postfix?: string | number;
};

export const analyticIdsVar: AnalyticIdsVar = makeVar({});

export const addAnalyticIdsVar = (id: AnalyticIdentifier, options?: AnalyticIdOptions): AnalyticIds => {
  const currentAnalyticIdsVar = analyticIdsVar();
  const internalId = makeCompoundAnalyticId(id, options);

  if (currentAnalyticIdsVar[internalId] === true) {
    throw createError(
      'RepeatedAnalyticsIdError',
      `Element id is already used in another component, analyticId: ${internalId}`,
    );
  }

  return analyticIdsVar({ ...currentAnalyticIdsVar, [internalId]: true });
};

export const deleteAnalyticIdsVar = (id: AnalyticIdentifier, options?: AnalyticIdOptions): AnalyticIds => {
  const currentAnalyticIdsVar = analyticIdsVar();
  const internalId = makeCompoundAnalyticId(id, options);

  delete currentAnalyticIdsVar[internalId];

  return analyticIdsVar({ ...currentAnalyticIdsVar });
};

const clearAllAnalyticIds = (): void => {
  analyticIdsVar({});
};

export const makeCompoundAnalyticId = (id: AnalyticIdentifier, options?: AnalyticIdOptions): string =>
  [id, options?.postfix].filter((value) => value !== undefined && value !== null && value !== '').join('-');

reactiveVarOrchestrator.registerClearFunction(clearAllAnalyticIds);
